var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUnshare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#C40005"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2476_44918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 14.7199C15.4933 14.7199 15.04 14.9199 14.6933 15.2333L9.94 12.4666C9.97333 12.3133 10 12.1599 10 11.9999C10 11.8399 9.97333 11.6866 9.94 11.5333L14.64 8.79325C15 9.12659 15.4733 9.33325 16 9.33325C17.1067 9.33325 18 8.43992 18 7.33325C18 6.22659 17.1067 5.33325 16 5.33325C14.8933 5.33325 14 6.22659 14 7.33325C14 7.49325 14.0267 7.64659 14.06 7.79992L9.36 10.5399C9 10.2066 8.52667 9.99992 8 9.99992C6.89333 9.99992 6 10.8933 6 11.9999C6 13.1066 6.89333 13.9999 8 13.9999C8.52667 13.9999 9 13.7933 9.36 13.4599L14.1067 16.2333C14.0733 16.3733 14.0533 16.5199 14.0533 16.6666C14.0533 17.7399 14.9267 18.6133 16 18.6133C17.0733 18.6133 17.9467 17.7399 17.9467 16.6666C17.9467 15.5933 17.0733 14.7199 16 14.7199Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2476_44918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnshare);
export default __webpack_public_path__ + "static/media/icon_unshare.436e23d17d5fb97758cf890d0ea69fc5.svg";
export { ForwardRef as ReactComponent };